import pic1 from "./InfluencerPictures/JoshPhone_Photos_1.jpg";
import pic2 from "./InfluencerPictures/JoshPhone_Photos_2.jpg";
import pic3 from "./InfluencerPictures/JoshPhone_Photos_3.jpg";
import pic4 from "./InfluencerPictures/JoshPhone_Photos_4.jpg";
import pic5 from "./InfluencerPictures/JoshPhone_Photos_5.jpg";
import pic6 from "./InfluencerPictures/JoshPhone_Photos_6.jpg";
import pic7 from "./InfluencerPictures/JoshPhone_Photos_7.jpg";
import newpic1 from "./InfluencerPictures/NewPic-01.webp";
import newpic2 from "./InfluencerPictures/NewPic-02.webp";
import newpic3 from "./InfluencerPictures/NewPic-03.webp";
// import pic8 from "./InfluencerPictures/JoshPhone_Photos_8.jpg";
import pic9 from "./InfluencerPictures/JoshPhone_Photos_9.jpg";
import pic10 from "./InfluencerPictures/JoshPhone_Photos_10.jpg";
import pic11 from "./InfluencerPictures/JoshPhone_Photos_11.jpg";
import pic12 from "./InfluencerPictures/JoshPhone_Photos_12.jpg";
import pic13 from "./InfluencerPictures/JoshPhone_Photos_13.jpg";
import pic14 from "./InfluencerPictures/JoshPhone_Photos_14.jpg";
import pic15 from "./InfluencerPictures/JoshPhone_Photos_15.jpg";
import Leogif from "./InfluencerPictures/leonardo-dicaprio.gif";
import TK_text_phot0 from "./InfluencerPictures/TK Text Photo.jpg";

export const LeoGif = {
  image: Leogif,
  date: "Sun 26 May 2024",
  time: "2:47PM",
};

export const TK_Text_photo = {
  image: TK_text_phot0,
  date: "Sun 26 May 2024",
  time: "10:28PM",
};

export const InfluencerPhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: pic1,
      date: "Thu 23 May 2024",
      time: "2:31 am",
      location: "Home",
    },
    pictures: [
      {
        image: pic1,
        date: "Thu 23 May 2024",
        time: "2:31 AM",
        location: "Home",
      },
      {
        image: pic2,
        date: "Thu 23 May 2024",
        time: "5:45 PM",
        location: "Home",
      },
      {
        image: pic3,
        date: "Sat 25 May 2024",
        time: "11:07 AM",
        location: "Bali",
      },
      {
        image: pic4,
        date: "Sat 25 May 2024",
        time: "1:11 PM",
        location: "Bali",
      },
      {
        image: pic5,
        date: "Sun 26 May 2024",
        time: "3:16 PM",
        location: "Bali",
      },
      {
        image: pic6,
        date: "Sun 26 May 2024",
        time: "8:34 PM",
        location: "Bali",
      },
      {
        image: pic7,
        date: "Sun 26 May 2024",
        time: "9:59 PM",
        location: "Bali",
      },
      {
        image: newpic3,
        date: "Sun 26 May 2024",
        time: "10:11 PM",
        location: "Bali",
      },
      {
        image: newpic2,
        date: "Sun 26 May 2024",
        time: "10:14 PM",
        location: "Bali",
      },
      {
        image: pic9,
        date: "Sun 26 May 2024",
        time: "10:15 PM",
        location: "Bali",
      },
      {
        image: pic10,
        date: "Sun 26 May 2024",
        time: "10:16 PM",
        location: "Bali",
      },
      {
        image: pic11,
        date: "Sun 26 May 2024",
        time: "10:17 PM",
        location: "Bali",
      },
      {
        image: newpic1,
        date: "Sun 26 May 2024",
        time: "10:17 PM",
        location: "Bali",
      },
      {
        image: pic13,
        date: "Sun 26 May 2024",
        time: "10:38 PM",
        location: "Bali",
      },
      {
        image: pic14,
        date: "Sun 26 May 2024",
        time: "10:38 PM",
        location: "Bali",
      },
      {
        image: pic15,
        date: "Sun 26 May 2024",
        time: "10:38 PM",
        location: "Bali",
      },
    ],
  },
];
